//   document.addEventListener("DOMContentLoaded", function(){
//       var link = document.querySelectorAll(".first-level-item");
//       link.forEach(linklist => {
        
//           linklist.onmouseover = function() {
//             var submenu = document.querySelectorAll(".second-level-list");
//             var grand_submenu = document.querySelectorAll(".third-level-list");
//             submenu.forEach(sublist => {
//               sublist.classList.remove('active');
//             });
//             grand_submenu.forEach(grandlist => {
//               grandlist.classList.remove('active');
//             });
//             link.forEach(linklist => {
//               linklist.classList.remove("active");
//             });
//             if(linklist.classList.contains('is_hover')) {
//               linklist.classList.add("active");
//               var linkattr = linklist.getAttribute("data-id");
//               document.getElementById(linkattr).classList.add('active');
//             }
//           };
        
//       });

//       var second_link = document.querySelectorAll(".second-level-item");
//       second_link.forEach(linklist => {
//         linklist.onmouseover = function() {
//           var main_menu = document.querySelectorAll(".first-level-list");
//           var grandmenu = document.querySelectorAll(".third-level-list");
//           grandmenu.forEach(grandmenulist => {
//             grandmenulist.classList.remove('active');
//           });
//           second_link.forEach(linklist => {
//             linklist.classList.remove("active");
//           });
//           main_menu.forEach(mainlist => {
//             linklist.classList.remove("active");
//           });
//           if(linklist.classList.contains('is_hover')) {
//             linklist.classList.add("active");
//             var linkattr = linklist.getAttribute("data-id");
//             document.getElementById(linkattr).classList.add('active');
//           }
//         };

//       });
//   }); 

document.addEventListener("DOMContentLoaded", function () {

  // --- Helpers ---
  function removeActiveItems(items) {
    items.forEach(function (item) {
      item.classList.remove("active");
      var a = item.querySelector(":scope > a");
      if (a) a.classList.remove("active");
    });
  }

  function removeActiveLists(lists) {
    lists.forEach(function (list) {
      list.classList.remove("active");
    });
  }

  function addActiveToItem(item) {
    item.classList.add("active");
    var a = item.querySelector(":scope > a");
    if (a) a.classList.add("active");
  }

  // --- Level selectors ---
  var firstLevelItems  = document.querySelectorAll(".first-level-item");
  var secondLevelItems = document.querySelectorAll(".second-level-item");
  var thirdLevelItems  = document.querySelectorAll(".third-level-item");
  var secondLevelLists = document.querySelectorAll(".second-level-list");
  var thirdLevelLists  = document.querySelectorAll(".third-level-list");

  // --- Activate Third Level Item ---
  function activateThirdLevel(item) {
    removeActiveItems(thirdLevelItems);
    addActiveToItem(item);
  }

  // --- Activate Second Level Item ---
  function activateSecondLevel(item) {
    removeActiveItems(secondLevelItems);
    removeActiveLists(thirdLevelLists);
    removeActiveItems(thirdLevelItems);

    addActiveToItem(item);

    // Open third-level list if item has children
    if (item.classList.contains("is_hover")) {
      var linkId = item.getAttribute("data-id");
      var thirdList = document.getElementById(linkId);
      if (thirdList) {
        thirdList.classList.add("active");
        // Auto-activate first third-level item
        var firstThird = thirdList.querySelector(".third-level-item");
        if (firstThird) activateThirdLevel(firstThird);
      }
    }
  }

  // --- Activate First Level Item ---
  function activateFirstLevel(item) {
    removeActiveItems(firstLevelItems);
    removeActiveLists(secondLevelLists);
    removeActiveItems(secondLevelItems);
    removeActiveLists(thirdLevelLists);
    removeActiveItems(thirdLevelItems);

    addActiveToItem(item);

    // Open second-level list if item has children
    if (item.classList.contains("is_hover")) {
      var linkId = item.getAttribute("data-id");
      var secondList = document.getElementById(linkId);
      if (secondList) {
        secondList.classList.add("active");
        // Auto-activate first second-level item
        var firstSecond = secondList.querySelector(".second-level-item");
        if (firstSecond) activateSecondLevel(firstSecond);
      }
    }
  }

  // --- Set Default Active on Page Load ---
  function setDefaults() {
    // First-level: pehla is_hover item default active
    var defaultFirst = document.querySelector(".first-level-item.is_hover");
    if (defaultFirst) {
      activateFirstLevel(defaultFirst);
    } else {
      // Agar koi is_hover nahi toh pehla item hi active
      var firstItem = document.querySelector(".first-level-item");
      if (firstItem) addActiveToItem(firstItem);
    }
  }

  // --- Hover Listeners ---
  firstLevelItems.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      activateFirstLevel(this);
    });
  });

  secondLevelItems.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      activateSecondLevel(this);
    });
  });

  thirdLevelItems.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      activateThirdLevel(this);
    });
  });

  // --- Init ---
  setDefaults();
});
